import {
    TMC_TASKS,
    TMC_PROJECTS,
    TMC_SERVERS,
    TMC_SERVER_BY_ID,
    TMC_EXECUTIONS_BY_TASK_ID,
    TMC_LOGS_BY_EXECUTION_ID
  } from "../actions/administration";
  import axios from "axios";
  
  const state = {
    accessToken: localStorage.getItem("access-token") || ""
  };
  
  const getters = {
  };
  
  const actions = {
    [TMC_TASKS]: ({ commit }, accessToken) => {
      return new Promise((resolve, reject) => {
        // Check if access token is present
        if (!accessToken) {
          const error = new Error("Access token not found");
          reject(error);
          return;
        }
        commit(TMC_TASKS);
        // Make the API call
        axios.get(process.env.VUE_APP_API + `/TMC/tasks`, {
          params: {
            access_token: accessToken
          }
        })
        .then(response => {
          localStorage.setItem("access-token", accessToken);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    [TMC_PROJECTS]: ({ commit }, accessToken) => {
      return new Promise((resolve, reject) => {
        // Check if access token is present
        if (!accessToken) {
          const error = new Error("Access token not found");
          reject(error);
          return;
        }
        commit(TMC_PROJECTS);
        // Make the API call
        axios.get(process.env.VUE_APP_API + `/TMC/projects`, {
          params: {
            access_token: accessToken
          }
        })
        .then(response => {
          localStorage.setItem("access-token", accessToken);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    [TMC_SERVERS]: ({ commit }, accessToken) => {
      return new Promise((resolve, reject) => {
        // Check if access token is present
        if (!accessToken) {
          const error = new Error("Access token not found");
          reject(error);
          return;
        }
        commit(TMC_SERVERS);
        // Make the API call
        axios.get(process.env.VUE_APP_API + `/TMC/servers`, {
          params: {
            access_token: accessToken
          }
        })
        .then(response => {
          localStorage.setItem("access-token", accessToken);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    [TMC_SERVER_BY_ID]: ({ commit }, { id, accessToken }) => {
      return new Promise((resolve, reject) => {
        // Check if access token is present
        if (!accessToken) {
          const error = new Error("Access token not found");
          reject(error);
          return;
        }
        commit(TMC_SERVER_BY_ID);
        // Make the API call
        axios.get(process.env.VUE_APP_API + `/TMC/remote-engines/${id}`, {
          params: {
            access_token: accessToken
          }
        })
        .then(response => {
          localStorage.setItem("access-token", accessToken);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    [TMC_EXECUTIONS_BY_TASK_ID]: ({ commit },{ executable, accessToken }) => {
      return new Promise((resolve, reject) => {
        // Check if access token is present
        if (!accessToken) {
          const error = new Error("Access token not found");
          reject(error);
          return;
        }
        commit(TMC_EXECUTIONS_BY_TASK_ID);
        // Make the API call
        axios.get(process.env.VUE_APP_API + `/TMC/executions/${executable}`, {
          params: {
            access_token: accessToken
          }
        })
        .then(response => {
          localStorage.setItem("access-token", accessToken);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    [TMC_LOGS_BY_EXECUTION_ID]: ({ commit },{ executionId, accessToken }) => {
      return new Promise((resolve, reject) => {
        // Check if access token is present
        if (!accessToken) {
          const error = new Error("Access token not found");
          reject(error);
          return;
        }
        commit(TMC_LOGS_BY_EXECUTION_ID);
        // Make the API call
        axios.get(process.env.VUE_APP_API + `/TMC/logs/${executionId}`, {
          params: {
            access_token: accessToken
          }
        })
        .then(response => {
          localStorage.setItem("access-token", accessToken);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
  
  };
  
  const mutations = {
    [TMC_TASKS]: (state, accessToken) => {
        state.accessToken = accessToken;
    },
    [TMC_PROJECTS]: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    [TMC_SERVERS]: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    [TMC_SERVER_BY_ID]: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    [TMC_EXECUTIONS_BY_TASK_ID]: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    [TMC_LOGS_BY_EXECUTION_ID]: (state, accessToken) => {
      state.accessToken = accessToken;
    }
  };
  
  export default {
    state,
    getters,
    actions,
    mutations
  };
  